import { SHARED_ROUTES } from '@aibees/shared/constants';
import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { useIsRanOutOfCredit } from '@aibees/shared/features/price-and-plan/hooks/use-is-ran-out-of-credit';
import { useSubscriptionExpiryInfo } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import { PLAN_EXPIRY_HIDDEN } from './constants';
import * as Styled from './styles';
import * as SX from './sx';
import type { SubscriptionBarProps as Props } from './types';

export const SubscriptionBar = memo(({ className }: Props) => {
  const { isExpiring, warningText } = useSubscriptionExpiryInfo();
  const { isLoading } = useCurrentSubscriptionApi();

  const ranOutOfCredit = useIsRanOutOfCredit();

  if (PLAN_EXPIRY_HIDDEN || isLoading) return null;

  if (!isExpiring && !ranOutOfCredit) return null;

  const text = ranOutOfCredit ? 'Credit Limit Reached.' : warningText;
  const buttonText = ranOutOfCredit ? 'Upgrade to continue' : 'Subscribe now';

  return (
    <Styled.Wrapper
      className={classnames('SubscriptionBar', className)}
      severity="error"
      variant="filled"
      icon={false}
      sx={SX.root}
    >
      <Typography variant="body2" fontWeight={600} sx={SX.text}>
        {text}
      </Typography>
      <Styled.Subscribe
        color="default"
        size="small"
        to={SHARED_ROUTES.priceAndPlan}
      >
        <span role="img" aria-label="rocket">
          🚀
        </span>
        <Typography variant="body3" fontWeight={600}>
          {buttonText}
        </Typography>
      </Styled.Subscribe>
    </Styled.Wrapper>
  );
});

SubscriptionBar.displayName = 'SubscriptionBar';
